import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

@Component({
    selector: 't4-SmsCodeDialog',
    templateUrl: 'SmsCodeDialog.html',
})
export class SmsCodeDialog {
    public retry: boolean;
    public pin: string = "";
    @ViewChild("txtPin", {static: false}) public txtPin: any;

    constructor(public dialogRef: MatDialogRef<SmsCodeDialog >, @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data.retry) {
            this.retry = true;
        }
    }

    public numberClicked(x: number) {
        this.pin += x;
        this.txtPin.nativeElement.focus()
    }

    public async bypassDigitalSignature() {
        this.dialogRef.close("NoCode");
    }

    public close(pin: string) {
        if(pin) this.dialogRef.close(pin);
    }
}
